export const state = () => ({
  viewedStories: []
})

export const mutations = {
  setViewedStories(state, stories) {
    state.viewedStories = stories || []
  },

  addViewedStory(state, storyId) {
    if (!state.viewedStories.includes(storyId)) {
      state.viewedStories.push(storyId)
    }
  },

  removeViewedStory(state, storyId) {
    state.viewedStories = state.viewedStories.filter(id => id !== storyId)
  },

  clearViewedStories(state) {
    state.viewedStories = []
  }
}

export const getters = {
  viewedStories: state => state.viewedStories,

  isStoryViewed: state => storyId => {
    return state.viewedStories.includes(storyId)
  },

  getUnviewedCount: state => stories => {
    return stories.filter(story => !state.viewedStories.includes(story.id)).length
  }
}

export const actions = {
  markStoryAsViewed({ commit }, storyId) {
    commit('addViewedStory', storyId)
  },

  resetStoriesState({ commit }) {
    commit('clearViewedStories')
  }
}
